export default __webpack_public_path__ + "img/op-additives.ac5394f6.png";